import { useCustomerAuthRequest } from 'hooks/useCustomerAuthApi/useCustomerAuthRequest';
import { CustomerAuthSession } from 'hooks/useCustomerAuthApi/const';

type RefreshTokenRequestState = {
  hasPending: boolean;
  request: (refreshToken?: RefreshToken) => Promise<CustomerAuthSession | undefined>;
  cancel: (message?: string) => void;
};

export type RefreshTokenRequestResult = RefreshTokenRequestState & [
  RefreshTokenRequestState['hasPending'],
  RefreshTokenRequestState['request'],
  RefreshTokenRequestState['cancel'],
];

export function useRefreshTokenRequest(): RefreshTokenRequestResult {
  return useCustomerAuthRequest((refreshToken?: RefreshToken) => {
    return refreshToken && ({
      method: 'PUT',
      url: '/sessions/refresh',
      headers: {
        authorization: refreshToken,
      }
    });
  }, []);
}
